<mat-sidenav-container class="example-container">
    <!-- <app-side-nav-bar [isMobile]="isMobile"></app-side-nav-bar> -->
    <!-- <div> -->
    <mat-sidenav #drawer style="background-color: #000832;color:#ffffff" [mode]="isMobile ? 'over' : 'side'"
        [opened]="isMobile ? false : false">
        <mat-nav-list class="side-nav-list">
            <button matFab extended class="side-btn" (click)="onOpenExtRegistration();drawer.toggle()">
                Request New User
            </button>
            @if (isAdmin) {
            <button matFab [routerLink]="`/${appRoutePaths[appRoutes.NotificationList]}`" extended class="side-btn"
                (click)="drawer.toggle();flyoutService.isResetFlyout.set(true)">
                Notifications
            </button>
            <button matFab [routerLink]="`/${appRoutePaths[appRoutes.AdminDashboard]}`" extended class="side-btn"
                (click)="drawer.toggle();flyoutService.isResetFlyout.set(true)">
                Applications
            </button>
            }
            <button matFab class="side-btn" (click)="onOpenTermsPopup();drawer.toggle()">
                Terms
            </button>
            <button matFab class="side-btn" (click)="drawer.toggle()">
                <a [href]="appLink.PrivacyPolicy" class="a-btn" target="_blank" rel="noopener noreferrer">
                    Privacy Policy
                </a>
            </button>
            <button matFab class="side-btn" (click)="drawer.toggle()">
                <a [href]="appLink.Navigator" class="a-btn" target="_blank" rel="noopener noreferrer">
                    Navigator
                </a>
            </button>
            <button matFab class="side-btn" (click)="drawer.toggle()">
                <a [href]="appLink.CPSwag" class="a-btn" target="_blank" rel="noopener noreferrer">
                    CP Swag
                </a>
            </button>
            <button matFab class="side-btn" (click)="onLogout();drawer.toggle()">
                Log Off
            </button>

        </mat-nav-list>
    </mat-sidenav>
    <!-- </div> -->

    <mat-sidenav-content class="bg-color" style="display: flex;
  min-height: 100%;
  flex-direction: column;">

        <mat-sidenav-container class="" [hasBackdrop]="hasBackdrop.value">
            <mat-sidenav style="   width: 60%" #sidenav [mode]="mode.value!" [position]="position.value!">
                <div style="    display: flex;
    justify-content: space-between;
    padding: 1% 3%;
    padding-top: 2%;">
                    <h2>{{getFlyoutHeader()}}</h2>

                    <mat-icon aria-hidden="false" (click)="sidenav.toggle();closeFlyoutHandle()"
                        aria-label="Example close icon" class="cursor-pointer" fontIcon="close"></mat-icon>
                </div>
                <ng-container class="table-container">
                    <div style="    margin: 0% 3%;margin-bottom:10px">
                        <mat-card appearance="outlined" style="border-radius: 10px !important;
                            border-color: grey !important;    padding: 0% 0%;">
                            @switch (openFlyout) {
                            @case (flyoutApplicationsEnum.applicationList) {
                            <app-admin-dashboard></app-admin-dashboard>
                            }
                            @case (flyoutApplicationsEnum.notificationList) {
                            <app-notification-list></app-notification-list>
                            }
                            }
                        </mat-card>
                    </div>
                </ng-container>
            </mat-sidenav>
            <mat-sidenav-content style="height: calc(100vh - 50px);">

                <app-header [isMobile]="isMobile" [drawer]="drawer"
                    (openExtRegistration)="clickExtRegistration($event)"></app-header>
                <div style="    padding-top: 5px;
        width: 87.4vw;
    justify-content: end;
    display: flex;">
                    <!-- <button matButton (click)="sidenav.toggle();openFlyoutHandle()">App List</button> -->
                    <!-- *ngIf="isAdmin && !isMobile"  -->
                    @if (isAdmin && !isMobile) {
                    <button matButton="filled" mat-raised-button
                        style="background-color: #0064ff;color:white; font-family: PeakSans_Regular !important;"
                        class="cp-btn-submit"
                        (click)="sidenav.toggle();openFlyoutHandle(flyoutApplicationsEnum.notificationList)">Notifications</button>

                    <button matButton="filled" mat-raised-button
                        style="background-color: #0064ff;color:white;font-family: PeakSans_Regular !important;"
                        class="cp-btn-submit"
                        (click)="sidenav.toggle();openFlyoutHandle(flyoutApplicationsEnum.applicationList)">Applications
                    </button>
                    }

                </div>
                <!-- <section> -->
                <router-outlet></router-outlet>
                <!-- </section> -->


                <app-footer [isMobile]="isMobile" (openTermsDialog)="onOpenTermsPopup()"></app-footer>
            </mat-sidenav-content>
        </mat-sidenav-container>
    </mat-sidenav-content>
</mat-sidenav-container>